import AjaxRequest from "./AjaxRequest";
import AxiosRequest from "./AxiosRequest";
import CallbackHandler from "./CallbackHandler";

export default class User {
    constructor() {
        this.results = [];
    }

    async get(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.getRequest().then(function (response) {
            if (response.status == 200) {
                return (self.results = callback.handleSuccess(
                    response,
                    "results"
                ));
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.results = "An error has occured, please try again";
            }
        });
    }

    async post(url, data = null, func, message) {
        const self = this;
        const callback = new CallbackHandler();
        const api = new AjaxRequest(url, data);

        await api.postRequest().then(function (response) {
            if (response.status == 200 || response.status == 422) {
                return (self.results = callback.handleSuccess(
                    response,
                    "results"
                ));
            } else {
                callback.handleError(
                    self.constructor.name,
                    func,
                    message,
                    response
                );

                self.results = "An error has occured, please try again";
            }
        });
    }

    async getSchools() {
        await this.get(
            "schools",
            null,
            "getSchools",
            "Could not fetch schools. Please refresh."
        );
        return this.results;
    }

    async searchSchoolContracts(search) {
        const data = {
            search: search,
        };
        await this.get(
            "schools/contracts/search",
            data,
            "searchSchoolContracts",
            "Could not perform search. Please refresh."
        );
        return this.results;
    }

    async sendResetLink(data) {
        await this.get(
            "password/reset",
            data,
            "sendResetLink",
            "Error occured while sending reset email. Please try again."
        );

        return this.results;
    }

    async updatePassword(data) {
        await this.post(
            "password/update",
            data,
            "updatePassword",
            "Could not update password. Please try again"
        );

        return this.results;
    }

    async resendEmail(data) {
        await this.post(
            "auth/email/resend",
            data,
            "resendEmail",
            "Failed to resend email. Try again later."
        );
        return this.results;
    }

    async loginGuid(data) {
        await this.post("auth/login-guid", data, "loginGuid", null);
        return this.results;
    }

    async saveField(field, data) {
        await this.post(
            `me/${field}`,
            data,
            "saveField",
            `Could not save ${field}. Please try again later.`
        );
        return this.results;
    }

    async changePassword(data) {
        await this.post(
            "me/password",
            data,
            "changePassword",
            "Could not save password. Please try again later."
        );
        return this.results;
    }

    async sendFeedback(data) {
        await this.post(
            "feedback",
            data,
            "sendFeedback",
            "Failed to send feedback. Try again later."
        );
        return this.results;
    }

    async getOriginAndSigninURL() {
        await this.get(
            "auth/getOriginAndSignInUrl",
            null,
            "getOriginAndSignInUrl",
            "Failed to get signin url. Try again later."
        );
        return this.results;
    }

    getUserSetting(key) {
        return new AxiosRequest().get('me/settings/' + key);
    }

    storeUserSetting(data) {
        return new AxiosRequest().post(`me/settings/store`, data);
    }
}
